module.exports = __webpack_public_path__ + "static/media/policy-number-health.97e14e03.svg";